module.exports = __webpack_public_path__ + "static/media/companyLogo.954c1ef6.png";